import { dealwithPcConsoleTimeline } from '@op/pages/gamestore/utils';
import { getGameStoreStatsInfo, getStudioGameStore } from '@op/services';
import { arrayToObj, arrayToSimpleObj } from '@op/utils';
import { useEffect, useMemo, useState } from 'react';
import { formatMessageIdConfig, PlatformMessageConfig } from '../config';
import moment from 'moment';

type SteamItemType = { review: number; score: number; };
export const getDefaultReview = () => ({ review: 0, score: 0 });
const channelMapItem: any = {
  xbox: 'lifetime',
  playstation: 'lifetime',
};

function dealwithOpencritic(
  list = [],
  channel: string,
  renderKey = 'top_critic_average',
) {
  const item = list.find((it: any) => it.key === renderKey);
  return {
    channel,
    review: 0,
    score: 0,
    ...(item || {}),
  };
}

export function useGameStorePcConsole({ filter }: any) {
  const [steamInfo, setSteamInfo] = useState<{
    all_reviews: SteamItemType;
    recent_reviews: SteamItemType;
  }>({
    all_reviews: getDefaultReview(),
    recent_reviews: getDefaultReview(),
  });

  const [trendTimeline, setTrendsTimeline] = useState({
    list: [],
    timeline_of_end_time: '',
    timeline_of_start_time: '',
  });

  const [bottomGameStore, setBottomGameStore] = useState<any>({});
  const [addedReviewCardData, setAddedReviewCardData] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [addedLoading, setAddedLoading] = useState(false);

  // 获取Added Reviews卡片数据
  function getAddedReviewCardData () {
    setAddedLoading(true);
    // setUserScoreApiError(false);
    const { start_time, end_time } = filter;
    const isToday =
        start_time?.substring(0, 10) === end_time?.substring(0, 10) &&
        end_time?.substring(0, 10) === moment().format('YYYY-MM-DD');
    getGameStoreStatsInfo({
      ...filter,
      channel: ["xbox"],
      channel_type: 'comments',
      types: ['selected'],
      is_today: isToday, // 前端判断是否是今天
    }).then((data: any) => {
      const { channel, mentions, score } = data?.[0]?.new_list?.[0] || {};
      const formattedData={
        channel,
        key: data?.[0]?.type,
        formatMessageId: formatMessageIdConfig.selectedXbox?.[data?.[0]?.type as keyof PlatformMessageConfig] || null,
        review: mentions,
        score
      };
      setAddedReviewCardData(data?.[0]?.new_list ? formattedData : null);
    })
      .finally(() => {
        setAddedLoading(false);
      });
  };

  function requestServerData() {
    setLoading(true);
    getStudioGameStore(filter)
      .then((data: any) => {
        const { list, timeline_of_end_time, timeline_of_start_time, timeline } =
          data || {};
        const filteredList = list?.filter((item: { channel: string; }) => 
          ['playstation', 'xbox', 'steam'].includes(item.channel)
        );
        const updatedList = filteredList?.map((item: { list: { key: string; }[]; channel: string; }) => ({
          ...item,
          list: item.list.map((subItem: { key: string; }) => ({
            ...subItem,
            formatMessageId: formatMessageIdConfig[item.channel]?.[subItem.key as keyof PlatformMessageConfig] || null, // 从配置中获取 formatMessageId
          })),
        }));
        const gameStoreMap = arrayToSimpleObj(updatedList, 'list', 'channel');
        const localTrendsTimeline: any = dealwithPcConsoleTimeline(
          [{ timeline, channel: 'steam' }],
          timeline_of_start_time,
          timeline_of_end_time,
        );
        setTrendsTimeline(localTrendsTimeline.steam);
        const { steam, ...otherInfo } = gameStoreMap || {};

        setBottomGameStore(otherInfo);
        setSteamInfo(arrayToObj(steam, 'key'));
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const renderList = useMemo(() => {
    const keys = Object.keys(bottomGameStore);
    const infoList = keys.reduce((pre: Array<any>, key: string) => {
      const list = bottomGameStore[key];
      const obj = dealwithOpencritic(list, key, channelMapItem[key]);
      if (obj.review === 0 && obj.score === 0) return pre;
      return [...pre, obj];
    }, []);
  
    const sortItems = Object.keys(channelMapItem);
    infoList.sort(
      (a, b) => sortItems.indexOf(a.channel) - sortItems.indexOf(b.channel),
    );
  
    // 如果 addedReviewCardData 有有效数据，插入到列表前面
    return addedReviewCardData ? [addedReviewCardData, ...infoList] : infoList;
  }, [bottomGameStore, addedReviewCardData]);

  useEffect(() => {
    if (!filter?.date_type) return;
    if (filter?.edition_unified_id) {
      getAddedReviewCardData();
      requestServerData();
    }
  }, [filter]);

  return {
    trendTimeline,
    steamInfo,
    bottomGameStore,
    loading: loading || addedLoading,
    bottomGameStoreRenderList: renderList,
  };
}
